exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement-type-container {\n  margin-bottom: 30px;\n}\n\n.col-date {\n  width: 45%;\n}\n\n.col-date-spacer {\n  width: 10%;\n  padding: 0 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/tender-selection/tender-selection.component.css
// module id = ../../../../../src/app/components/new-simulation/tender-selection/tender-selection.component.css
// module chunks = main